import React from "react";

import OverallPrimo from "../Garments/OverallPrimo";

export default function OverallPrimoPage() {
  return <OverallPrimo />;
}
